import { filter, find, map, reduce, sumBy } from "lodash";

import type { Product } from "../types/Product";
import type { CartItem } from "../types/Cart";

export function decrementFromCart(
  cart: CartItem[],
  productId: number,
): CartItem[] {
  const existingItem = find(cart, (item) => item.id === productId);

  if (existingItem) {
    if (existingItem.quantity === 1) {
      return filter(cart, (item) => item.id !== productId);
    }

    return map(cart, (product) => {
      return product.id === productId
        ? { ...product, quantity: product.quantity - 1 }
        : product;
    });
  }

  return cart;
}

export function addToCart(cart: CartItem[], product: Product): CartItem[] {
  const existingItem = find(cart, (item) => item.id === product.id);

  if (!existingItem) {
    return [...cart, { ...product, quantity: 1 }];
  }

  return map(cart, (item) =>
    item.id === product.id ? { ...item, quantity: item.quantity + 1 } : item,
  );
}

export function calculateCartTotal(cart: CartItem[]): number {
  return reduce(cart, (total, item) => total + item.price * item.quantity, 0);
}

export function calculateItemTotal(item: CartItem): number {
  return item.price * item.quantity;
}

export function calculateItemCountInCart(cart: CartItem[]): number {
  return sumBy(cart, "quantity");
}
